(function() {
  'use strict';

  angular
    .module('service.survey')
    .factory('PreviewSurveyService', PreviewSurveyService);

  PreviewSurveyService.$inject = ['ServiceHelper', '$q'];

  function PreviewSurveyService(ServiceHelper, $q) {

    var service = {
      answerQuestion: answerQuestion
    };

    return service;

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    function answerQuestion(answer, resultCb, errorCb) {
      return respond($q.resolve({
        data: {
          surveyId: answer.surveyId,
          questionId: answer.questionId,
          action: 'answerQuestion'
        }
      }), resultCb, errorCb);
    }
  }
})();
